module.exports = __webpack_public_path__ + "img/US.2121423a.svg";